import {ControlBuilder} from './control-builder.type';
import {AsyncValidatorFn, ValidatorFn, Validators} from '@angular/forms';
import {FieldConfig} from './field.config';
import {customEmailValidator, customTimeValidator} from '../validation/custom-validatror';

export const defaultControlBuilder: ControlBuilder = (config, formBuilder) => {
    const {disabled, value} = config;

    const validators = buildDefaultValidators(config);
    const asyncValidators = buildAsyncValidators(config);

    return formBuilder.control(
        {
            disabled,
            value: value || null
        },
        validators,
        asyncValidators
    );
};

export const buildDefaultValidators = (config: FieldConfig<any>): ValidatorFn[] => {
    // normalization  to an array
    const rawValidators = config.validators ?? [];
    const validatorsArray = Array.isArray(rawValidators)
        ? rawValidators
        : [rawValidators];

    // Replace Validators.email if present
    const replacedValidators = validatorsArray.map((v) => {
        if (v === Validators.email) {
            return customEmailValidator;
        }
        return v;
    });

    // Add time validator for time fields if not already present
    if (config.type === 'time' && !replacedValidators.includes(customTimeValidator)) {
        replacedValidators.push(customTimeValidator);
    }

    if (config.required && !replacedValidators.includes(Validators.required)) {
        replacedValidators.push(Validators.required);
    }

    return replacedValidators;
};

export const buildAsyncValidators: (fieldConfig: FieldConfig<any>) => AsyncValidatorFn[] =
    (config): AsyncValidatorFn[] => {
        // normalization  to an array so it was always array
        const rawAsyncValidators = config.asyncValidators ?? [];
        return Array.isArray(rawAsyncValidators)
            ? rawAsyncValidators
            : [rawAsyncValidators];
    };

